var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2042 2.82046C5.57962 2.64545 6.02584 2.80792 6.20085 3.18334C6.37586 3.55876 6.2134 4.00498 5.83797 4.18C3.21382 5.4033 1.5 8.04157 1.5 10.9914C1.5 15.1386 4.85759 18.5002 8.99894 18.5002C13.1403 18.5002 16.4979 15.1386 16.4979 10.9914C16.4979 8.04766 14.7912 5.41389 12.1753 4.18718C11.8002 4.01131 11.6388 3.56472 11.8147 3.1897C11.9905 2.81467 12.4371 2.65322 12.8121 2.82909C15.9502 4.30065 17.9979 7.46066 17.9979 10.9914C17.9979 15.9666 13.9691 20.0002 8.99894 20.0002C4.02876 20.0002 0 15.9666 0 10.9914C0 7.45334 2.05623 4.28796 5.2042 2.82046ZM8.99894 0.496094C9.37864 0.496094 9.69243 0.778248 9.74209 1.14432L9.74894 1.24609V8.74603C9.74894 9.16024 9.41315 9.49603 8.99894 9.49603C8.61925 9.49603 8.30545 9.21387 8.25579 8.8478L8.24894 8.74603V1.24609C8.24894 0.83188 8.58473 0.496094 8.99894 0.496094Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIcon);
export default __webpack_public_path__ + "static/media/power-icon.18c0950238c8c14ab94108e12003a965.svg";
export { ForwardRef as ReactComponent };